import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3197e9ca&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=3197e9ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3197e9ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3197e9ca')) {
      api.createRecord('3197e9ca', component.options)
    } else {
      api.reload('3197e9ca', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=3197e9ca&scoped=true&", function () {
      api.rerender('3197e9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/familyMotto/detail.vue"
export default component.exports